export const REVIEWS_PER_PAGE = 30;
